import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
export function useRedirectParam() {
  const $ = _c(2);
  const params = useSearchParams();
  let t0;
  if ($[0] !== params) {
    t0 = params?.get("redirect") ?? null;
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}